import { Component } from 'react';
import { connect } from 'react-redux';

import { thunks } from '../../redux/modules/notifications';
import { NOTIFICATION_TIMER } from '../../constants';
import { getAuthToken } from '../../utils';

class NotificationLoader extends Component {
    componentDidMount() {
        this.getNotifications();
        setInterval(this.getNotifications, NOTIFICATION_TIMER);
    }

    getNotifications = () => {
       if(getAuthToken()) {
           const { dispatch } = this.props;
           dispatch(thunks.getNotifications());
       }
    }

    render() {
        return null;
    }
}

const mapDispatchToProps = dispatch => ({
    dispatch,
});

export default connect(() => ({}), mapDispatchToProps)(NotificationLoader)